// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__294kT","error":"Label_error__TNOvw"};